<template>
  <CCol md="6">
    <div class="w-100">
      <div class="clearfix">
        <div class="float-left mr-4">
          <img alt="Leadgrease logo" class="leadgrease-logo" src="@sset/img/logo.png" />
        </div>
        <h1 class="display-5">
            {{ $t("Welcome to your") }}
            <span>Leadgrease App</span><br/>
            <span v-if="authenticated">{{user.first_name}}</span>

        </h1>
        <h3 class="text-muted">
          <template v-if="authenticated">
            <router-link class="btn btn-link" :to="{ name: 'dashboard' }">
              {{ $t('Dashboard') }}
            </router-link>
          </template>
          <template v-else>
            <router-link class="btn btn-link" :to="{ name: 'register' }">
              {{ $t('Register') }}
            </router-link>
            <router-link class="btn btn-link" :to="{ name: 'login' }">
              {{ $t('Login') }}
            </router-link>
          </template>
        </h3>
      </div>
    </div>
  </CCol>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: "Welcome",

  layout: "basic",

  metaInfo() {
    return { title: this.$t(this.$route.name) };
  },

  computed: mapGetters({
    authenticated: 'auth/check',
    user:'auth/user'
  })
};
</script>

<style scoped lang="scss">
    h1.display-5 {
        & span {
            color: #42b983;
            font-weight: 600;

            &:last-child {
                color: #3c4b64;
            }
        }
    }

    a {
        color: #42b983;
    }

    .leadgrease-logo{
        height: 12rem;
        width: auto;
    }
</style>
